import React from "react";
import { motion } from "framer-motion";
import "./BaseForm.css";
import Form from "./Form";
import FormSvg from "../../svg/FormSvg";
import Img from "../../images/form.jpg";

const BaseForm = (props) => {
    return (
        <motion.div
            id="form"
            style={{ backgroundColor: props.type !== "up" ? "#fff" : "" }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ ease: "easeOut", duration: 1 }}
        >
            <div className="text">
                <p className="orange">Заявка</p>
                <h2 className="primary">{props.title || "Получите специальную цену"}</h2>
                <p className="opacity-50">{props.description || "Оставьте заявку, чтобы получить выгодные условия"}</p>
            </div>
            {props.type === "up" ? <FormSvg className="svg" /> : <img src={Img} alt="" className="img" />}
            <Form formId={"body"} typeOfPremises={props.typeOfPremises} />
        </motion.div>
    );
};

export default BaseForm;
